import PricingPage from "views/Pages/PricingPage.jsx";
import FaqPage from "views/Pages/FaqPage.jsx";
import ErrPage from "views/Pages/ErrPage.jsx";
// import LoginPage from "views/Pages/LoginPage.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import LoginPageIdaman from "views/Pages/LoginPageIdaman.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import LockScreenPage from "views/Pages/LockScreenPage.jsx";
import QuestionerPage from "views/Pages/QuestionerPage.jsx";
// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";
import Fingerprint from "@material-ui/icons/Fingerprint";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import FAQs from "@material-ui/icons/QuestionAnswer";
import LockOpen from "@material-ui/icons/LockOpen";
import AddComment from "@material-ui/icons/AddComment"

const pagesRoutes = [
  {
    path: "/pages/register-page",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: RegisterPage
  },
  {
    path: "/pages/login",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage
  },
  {
    path: "/pages/loginidaman",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPageIdaman
  },

  // {
  //   path: "/pages/pricing-page",
  //   name: "Pricing Page",
  //   short: "Pricing",
  //   mini: "PP",
  //   icon: MonetizationOn,
  //   component: PricingPage
  // },
  {
    path: "/pages/faq",
    name: "FAQ",
    short: "FAQ",
    mini: "faq",
    icon: FAQs,
    component: FaqPage
  },
  {
    path: "/pages/403",
    name: "FAQ",
    short: "FAQ",
    mini: "faq",
    icon: FAQs,
    component: ErrPage
  },
  // {
  //   path: "/pages/lock-screen-page",
  //   name: "Lock Screen Page",
  //   short: "Lock",
  //   mini: "LSP",
  //   icon: LockOpen,
  //   component: LockScreenPage
  // },
  {
    redirect: true,
    path: "/pages",
    pathTo: "/pages/login",
    name: "Login Page"
  }
];

export default pagesRoutes;
